import React from "react";
import { Icon } from "./icons";

export const Services = ({ data }) => (
  <section id="services" className="section services">
    <div className="container">
      <h2 className="section-title">Nos services</h2>

      <div className="services-grid">
        {(data || []).map((s) => {
          const Tag = s.href ? "a" : "article";
          return (
            <Tag className="service-card" key={s.title} href={s.href}>
              <span className="service-icon">
                <Icon name={s.icon} size={34} />
              </span>
              <h3>{s.title}</h3>
              <p>
                {s.lines.map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </p>
            </Tag>
          );
        })}
      </div>
    </div>
  </section>
);

export default Services;
